//wellabp-2025

//import "./modules/asset-selection-form.js"
import "./modules/team-and-user-management.js"
import "./modules/formidable-campaign-briefing.js"
import "./modules/asset-briefing.js"
import "./modules/load-briefing.js"
import "./modules/send-briefing.js"
import "./modules/delete-briefing.js"
import "./modules/duplicate-briefing.js"
import "./modules/briefing-feeds.js"
import "./modules/dashboard.js"
import { oxgAssetBriefingPriceEst } from "./modules/asset-briefing-price-estimation.js";

window.oxgAssetBriefingItems = new Array
window.oxgAssetBriefingCurrentSave = {
    isActive: false,
    saveName: null,
    oxgId: null,
    unsavedChanges: false,
    teamId: null,
}
window.oxgAssetBriefingMeta = {
    title: null,
    deadline: null,
    comment: null,
}
window.oxgDatepickers = null

document.addEventListener('DOMContentLoaded', () => { 

    let isBriefingDetailPage = document.querySelector('.briefing-defail-page')
    if(isBriefingDetailPage) {
        oxgAssetBriefingPriceEst()
    }

    let projectJsEvent = new Event('projectJsLoaded');
    document.dispatchEvent(projectJsEvent);
    //console.log(performance.now() + ': Project log: DOM Content loaded')
    //window.onload = function() { console.log(performance.now() + ': Project log: window loaded') }

});

